import React from 'react';
import Image2 from '../../assest/homestay/29.jpeg'
import Image1 from '../../assest/farmstay/76.jpg'
import './exclusivelistings.scss'
// import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";


const ExclusiveListings = () => {
	// const navigate = useNavigate();

	// const handlehomeone = () => {
	// 	navigate('/farmstays')
	// }

	// const handlehometwo = () => {
	// 	navigate('/homestays')
	// }

	return (
		<section className="property-section">
			<div className="property-header">

				<div className="left">
					<span className="ExclusiveListingstag">Featured Stays</span>
					<h2 className="title">Handpicked Stays for You</h2>
				</div>

				{/*<button className="explore-btn">*/}
				{/*	Explore all 48 listings →*/}
				{/*</button>*/}

			</div>

			<div className="property-grid">

				{/* First Property Card */}
				<div className="property-card">
					<div className="card-image">
						<img src={Image1} alt="Home 1" />
						<span className="badge">Featured</span>
					</div>

					<div className="card-content">
						<div className="card-top">
							<h3>🌿 Farm Stay</h3>
							<span className="price">₹ 4000* <small>/Night</small> <small>{" "}(Upto 8 people*)</small></span>
						</div>

						<p className="location">📍 Hattur, Bijapur road, Solapur, Maharashtra, India </p>

						<div className="features">
							<div className="feature-item">🛏️ 2BHK Cottage</div>
							<div className="feature-item">🅿️ Parking</div>
							<div className="feature-item">🌿 Private Garden</div>
							<div className="feature-item">🛋️ Fully Furnished</div>
							<div className="feature-item">🏊 Private Pool</div>
							<div className="feature-item">⚽ Turf</div>
						</div>
						<div className="feature-items">🕒 Check-in:11:00 AM Check-out: 10:00 AM</div>

						<Link className="view-btn" to="/farmstays">View Details</Link>
					</div>
				</div>

				{/* Second Property Card */}
				<div className="property-card">
					<div className="card-image">
						<img src={Image2} alt="Ethereal Heights" />
					</div>

					<div className="card-content">
						<div className="card-top">
							<h3>🏡 Home Stay</h3>
							<span className="price">₹ 2500* <small>/Night</small> <small>{" "}(Upto 5 people*)</small></span>
						</div>

						<p className="location">📍 Saiful(Near Bijapur Road) Solapur, Maharashtra, India </p>

						<div className="features">
							<div className="feature-item">🛏️ 2BHK</div>
							<div className="feature-item">🅿️ Parking</div>
							<div className="feature-item">❄️ Air Conditioning</div>
							<div className="feature-item">🚰 RO System</div>
							<div className="feature-item">💧 24 Hour Water</div>
							<div className="feature-item">🛋️ Fully Furnished</div>
							{/* <div className="feature-item">🕙 Check-out: <strong>10:00 AM</strong></div> */}
						</div>
						<div className="feature-items">🕒 Check-in:11:00 AM Check-out: 10:00 AM</div>

						<Link className="view-btn" to="/homestays">View Details</Link>
					</div>
				</div>

			</div>
		</section>
	);
};

export default ExclusiveListings;